<template>
  <div class='not-found'>
    <img src='../assets/404.png'/>
  </div>
</template>

<script>
  export default {
    name: '404'
  }
</script>

<style lang="less" scoped>
.not-found {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 100px 0;
  > img {
    width: 800px;
  }
}
</style>